module.exports = __webpack_public_path__ + "img/compress.17e87740.svg";